"use client";

import { BSRHeart } from "./bsr/BSRHeart";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Heart as LegacyHeart } from "./legacy/Heart";

export const Heart = createBSRExperimentIcon(LegacyHeart, BSRHeart);
